var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3592 6.64076L14.5858 5.41421C15.3668 4.63317 16.6332 4.63316 17.4142 5.41421L22.5858 10.5858C23.3668 11.3668 23.3668 12.6332 22.5858 13.4142L19.001 16.999C18.4032 17.5968 18.255 18.51 18.6331 19.2661C20.8186 23.6372 24.3628 27.1814 28.7339 29.3669C29.49 29.745 30.4032 29.5968 31.001 28.999L34.5858 25.4142C35.3668 24.6332 36.6332 24.6332 37.4142 25.4142L42.5858 30.5858C43.3668 31.3668 43.3668 32.6332 42.5858 33.4142L41.3592 34.6408C37.1365 38.8635 30.4514 39.3386 25.674 35.7555L23.2571 33.9429C19.7701 31.3276 16.6724 28.2299 14.0571 24.7429L12.2445 22.326C8.66144 17.5486 9.13654 10.8635 13.3592 6.64076Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/Phone_fill.ff8e9afe4f9485e562cc37094ebb3289.svg";
export { ForwardRef as ReactComponent };